module.exports = __webpack_public_path__ + "static/img/pattern_third.e4edc169.png";